import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTermDepositListStatementService,
  fetchTermDepositStatementAuthService,
  fetchTermDepositStatementConfirmService,
  fetchTermDepositStatementCreateService,
} from "../services/term-deposit-statement.service";
import {
  fetchTermDepositListStatementFailure,
  fetchTermDepositListStatementSuccess,
  fetchTermDepositStatementAuthorizationFailure,
  fetchTermDepositStatementAuthorizationSuccess,
  fetchTermDepositStatementConfirmFailure,
  fetchTermDepositStatementConfirmSuccess,
  fetchTermDepositStatementCreateFailure,
  fetchTermDepositStatementCreateSuccess,
} from "./actions";
import {
  FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_REQUEST,
  FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_REQUEST,
  FETCH_TERM_DEPOSIT_STATEMENT_CREATE_REQUEST,
  FETCH_TERM_DEPOSIT_STATEMENT_REQUEST,
} from "./actions.type";
import {
  FetchTermDepositStatementAuthorizationRequest,
  FetchTermDepositStatementConfirmRequest,
  FetchTermDepositStatementCreateRequest,
} from "./types";

function* fetchTermDepositListStatementSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchTermDepositListStatementService);
    console.log("fetchTermDepositListStatement response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositListStatementSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositListStatementFailure(msg));
  }
}

function* fetchTermDepositStatementCreateSaga(action: FetchTermDepositStatementCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositStatementCreateService(action));
    console.log("fetchTermDepositStatementCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositStatementCreateSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositStatementCreateFailure(msg));
  }
}

function* fetchTermDepositStatementConfirmSaga(action: FetchTermDepositStatementConfirmRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositStatementConfirmService(action));
    console.log("fetchTermDepositStatementConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositStatementConfirmSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositStatementConfirmFailure(msg));
  }
}

function* fetchTermDepositStatementAuthSaga(action: FetchTermDepositStatementAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositStatementAuthService(action));
    console.log("fetchTermDepositStatementAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositStatementAuthorizationSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositStatementAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* termDepositStatementSaga() {
  yield all([
    takeLatest(FETCH_TERM_DEPOSIT_STATEMENT_REQUEST, fetchTermDepositListStatementSaga),
    takeLatest(FETCH_TERM_DEPOSIT_STATEMENT_CREATE_REQUEST, fetchTermDepositStatementCreateSaga),
    takeLatest(FETCH_TERM_DEPOSIT_STATEMENT_CONFIRM_REQUEST, fetchTermDepositStatementConfirmSaga),
    takeLatest(FETCH_TERM_DEPOSIT_STATEMENT_AUTHORIZATION_KEY_REQUEST, fetchTermDepositStatementAuthSaga),
  ]);
}

export default termDepositStatementSaga;
